import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ThemeProvider } from "./lib/theme";
import "./lib/i18n";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Landing from "./pages/Landing";
import ProductDetail from "./pages/ProductDetail";
import BootSplash from "./components/BootSplash";
import { trackPageView, attachScrollDepthTracker } from "./lib/analytics";

const ScrollHandler = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 80);
      }
    }
  }, [location]);
  return null;
};

// Fires a GA4 page_view on every SPA route change (initial + subsequent).
const AnalyticsRouteTracker = () => {
  const location = useLocation();
  useEffect(() => {
    // Wait a tick so Helmet has updated document.title
    const t = setTimeout(
      () => trackPageView(location.pathname + location.search, document.title),
      50
    );
    return () => clearTimeout(t);
  }, [location.pathname, location.search]);
  return null;
};

function App() {
  useEffect(() => {
    // one-shot 25/50/75/100 scroll-depth events, useful for engagement audiences in Ads
    return attachScrollDepthTracker();
  }, []);

  return (
    <div className="App relative">
      <HelmetProvider>
        <ThemeProvider>
          <BootSplash />
          <BrowserRouter>
            <ScrollHandler />
            <AnalyticsRouteTracker />
            <Header />
            <main className="relative">
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/loyalty" element={<ProductDetail />} />
                <Route path="/review" element={<ProductDetail />} />
                <Route path="/connect" element={<ProductDetail />} />
                <Route path="/page" element={<ProductDetail />} />
                <Route path="/booking" element={<ProductDetail />} />
                <Route path="/luckywheel" element={<ProductDetail />} />
                <Route path="*" element={<Landing />} />
              </Routes>
            </main>
            <Footer />
          </BrowserRouter>
        </ThemeProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
